




































import { Component, Prop, Mixins } from 'vue-property-decorator';
import RatingSelectComponentMixin from '@/mixins/ratingSelectComponentMixin';
@Component
export default class RatingSelect extends Mixins(RatingSelectComponentMixin) {
  @Prop({ type: Number, default: 5 }) maxValue!: number;
}
